
// import { error } from 'weixin-js-sdk'
import requestUrl from '../api/index'
import store from '@/store'
const getWxConf = async() => {
    // const url = /(Android)/i.test(navigator.userAgent) ? location.href.split('#')[0] : window.entryUrl
    // // const url = 'https://pre-sidebar.fkjz.cn'
    // // console.log(url, 'url')

    // const { data } = await $request.postRequest({
    //     url   : requestUrl.main.getTicketSignature,
    //     params: {
    //         url
    //     }
    // })
    // console.log('data', data)
    // store.commit('user/SET_CORP_ID', data.company_id)

    const corpId = store.getters.corpId
    const agentId = store.getters.agentId
    const timestamp = store.getters.timestamp
    const noncestr = store.getters.noncestr
    const companySignature = store.getters.companySignature
    const signature = store.getters.signature

    $wx.register({
        corpId, // 必填，当前用户企业所属企业ID
        agentId,

        jsApiList: [
            'checkJsApi',
            'getNetworkType',
            'getLocation',
            'scanQRCode',
            'getCurExternalContact',
            'getExternalContact',
            'selectExternalContact',
            'openEnterpriseChat'
        ],
        getConfigSignature() {
            return {
                timestamp: timestamp, // 必填，生成签名的时间戳
                nonceStr : noncestr, // 必填，生成签名的随机串
                signature: companySignature // 必填，签名，见附录1
            }
        },
        getAgentConfigSignature() {
            return {
                timestamp: timestamp, // 必填，生成签名的时间戳
                nonceStr : noncestr, // 必填，生成签名的随机串
                signature: signature // 必填，签名，见附录1
            }
        },
        onConfigSuccess() {
            console.log('onConfigSuccess初始化成功')
        },
        onConfigFail(err) {
            console.log('onConfigSuccess初始化失败', err)
        },
        onAgentConfigSuccess() {
            console.log('onAgentConfigSuccess初始化成功')
        },
        onAgentConfigFail(err) {
            console.log('onAgentConfigFail初始化失败', err)
        },
        onAgentConfigComplete(err) {
            console.log('agentConfig 完成回调', err)
        },
        onConfigComplete(res) {
            console.log('res', res)
        }
    })

    // const content = await $wx.getContext()
    // console.log(content, 'content的场景')

    try {
        $wx.getCurExternalContact({
            success: (userIdRes) => {
                console.log(userIdRes, '用户信息')
                store.commit('user/SET_userIdRes', userIdRes)
            },
            fail: (err) => {
                console.log('err0r', err)
                if (err.errMsg === 'getCurExternalContact:without context of external contact') {
                    // todo 跳转到缺省页 功能开发中~
                    console.log('跳转到缺省页 功能开发中~')
                }
            },
            complete: (res) => {
                console.log(res, 'complete===>')
            }
        })
    } catch (error) {
        console.log('error===>err', error)
    }
}

// 获取appid
const getCorpId = async() => {
    const url = /(Android)/i.test(navigator.userAgent) ? location.href.split('#')[0] : window.entryUrl

    const { data } = await $request.postRequest({
        url   : requestUrl.main.getTicketSignature,
        params: {
            url
        }
    })
    console.log('data1', data)
    store.commit('user/SET_CORP_ID', data.company_id)
    store.commit('user/SET_AGENT_ID', data.agent_id)
    store.commit('user/SET_TIMESTAMP', data.timestamp)
    store.commit('user/SET_NONCESTR', data.noncestr)
    store.commit('user/SET_COMPANY_SIGNATURE', data.companySignature)
    store.commit('user/SET_SIGNATURE', data.signature)
}
export {
    getWxConf,
    getCorpId
}
